import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import UploadIcon from "@mui/icons-material/Upload";
import {
  Box,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import React, { useEffect, useState } from "react";
import useIsMobile from "../Hooks/useIsMobile";
import apiService from "../Services/api.service";
import ConfirmationPopup from "./ConfirmationPopup";
import { useToast } from "./Toast";
const TransactionsList = ({ history, kioskId }) => {
  const [transactions, setTransactions] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState();
  const [openPopup, setOpenPopup] = useState(false);
  const [isUrlMap, setIsUrlMap] = useState({});
  const Toast = useToast();
  const isMobile = useIsMobile();
  const token = localStorage.getItem("token");
  const handleOpenPopup = (transactionId) => {
    setOpenPopup(true);
    setId(transactionId);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  const handleConfirm = async (transactionId) => {
    setOpenPopup(false);

    try {
      setIsLoading(true);

      const result = await apiService.DeleteTransaction(kioskId, transactionId, token);
    

      setIsLoading(false);
      Toast.success("Transaction Deleted successfully!");
      window.location.reload();
    } catch (error) {
      console.error(
        "Error during upload:",
        error.response?.data || error.message
      );
      Toast.error("Transaction Delete failed. Please try again.");
    }
  };

  const handleDownload = async (transactionId) => {
    try {
      const fileUrl = await apiService.getReceiptFileUrl(
        kioskId,
        transactionId,
        token
      );
      const url = fileUrl.receipt.url;
      if (url) {
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank"; // Open in a new tab if required
        link.rel = "noopener noreferrer"; // Security best practice
        link.click();
      } else {
        Toast.error("There is no receipt found for this transaction");
        console.error("File URL not returned from the API");
      }
    } catch (error) {
      console.error("Error downloading the contract:", error);
    }
  };
  const handleUpload = async (transactionId) => { 
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "*/*";
    fileInput.style.display = "none";

    fileInput.onchange = async (event) => {
      const file = event.target.files[0];
      if (file) {
        setSelectedFile(file); 

        try {
          setIsLoading(true);

          const result = await apiService.uploadReceipt(
            kioskId,
            transactionId,
            file,
            token
          ); 

          setIsLoading(false);
          Toast.success("File uploaded successfully!");
          window.location.reload();
        } catch (error) {
          console.error(
            "Error during upload:",
            error.response?.data || error.message
          );
          Toast.error("File upload failed. Please try again.");
        }
      }
    };

    fileInput.click();
  };
  useEffect(() => { 
    if (Array.isArray(history)) {
      const updatedTransactions = history.map((transaction) =>
        transaction.currency === "INR"
          ? { ...transaction, amount: transaction.amount / 100 }
          : transaction
      );
      setTransactions(updatedTransactions);
    }
    if (Array.isArray(history)) {
      const updatedUrlMap = {};

      history.forEach((transaction) => {
        updatedUrlMap[transaction._id] = transaction.receipt.url !== "";
      });

      setIsUrlMap(updatedUrlMap);
    }
  }, [history]);

  return (
    <Box>
      <CardContent>
        <Typography variant="h4" gutterBottom>
          Transactions
        </Typography>
        {isMobile ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {transactions.map((transaction, index) => (
              <Card
                key={transaction._id || index}
                sx={{ boxShadow: 3, position: "relative" }}
              >
                <IconButton
                  color="primary"
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                  }}
                  onClick={() => handleOpenPopup(transaction._id)}
                >
                  <DeleteIcon />
                </IconButton>

                <CardContent>
                  <Typography variant="h6" fontWeight="bold">
                    Amount: {transaction.amount} {transaction.currency}
                  </Typography>
                  <Typography variant="body2">
                    Transaction ID: {transaction.transactionId}
                  </Typography>
                  <Typography variant="body2">
                    Date:{" "}
                    {new Date(transaction.transactionDate).toLocaleDateString()}
                  </Typography>
                  <Typography variant="body2">
                    Payment Method: {transaction.method}
                  </Typography>
                  <Tooltip title={transaction.notes || "No Notes"} arrow>
                    <Typography
                      variant="body2"
                      noWrap
                      sx={{
                        maxWidth: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      Notes: {transaction.notes || "N/A"}
                    </Typography>
                  </Tooltip>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="body2" sx={{ flexShrink: 0 }}>
                      Receipt:
                    </Typography>
                    <IconButton
                      color="primary"
                      onClick={() =>
                        isUrlMap[transaction._id]
                          ? handleDownload(transaction._id)
                          : handleUpload(transaction._id)
                      }
                    >
                      {isUrlMap[transaction._id] ? (
                        <DownloadIcon />
                      ) : (
                        <UploadIcon />
                      )}
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {[
                    "Amount",
                    "Currency",
                    "Date",
                    "Payment Method",
                    "Transaction ID",
                    "Notes",
                    "Receipt",
                    "  ",
                  ].map((header) => (
                    <TableCell
                      key={header}
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {transactions.map((transaction, index) => (
                  <TableRow key={transaction._id || index}>
                    <TableCell align="center">{transaction.amount}</TableCell>
                    <TableCell align="center">{transaction.currency}</TableCell>
                    <TableCell align="center">
                      {new Date(transaction.transactionDate).toLocaleDateString(
                        "en-GB"
                      )}
                    </TableCell>

                    <TableCell align="center">{transaction.method}</TableCell>
                    <TableCell align="center">
                      {transaction.transactionId}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        maxWidth: 100,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Tooltip title={transaction.notes || "No Notes"}>
                        <span>{transaction.notes || "N/A"}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        color="primary"
                        onClick={() =>
                          isUrlMap[transaction._id]
                            ? handleDownload(transaction._id)
                            : handleUpload(transaction._id)
                        }
                      >
                        {isUrlMap[transaction._id] ? (
                          <DownloadIcon />
                        ) : (
                          <UploadIcon />
                        )}
                      </IconButton>
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => handleOpenPopup(transaction._id)}
                      >
                        <DeleteIcon sx={{ fontSize: 17 }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
      <ConfirmationPopup
        open={openPopup}
        onClose={handleClosePopup}
        onConfirm={() => handleConfirm(id)}
      />
    </Box>
  );
};

export default TransactionsList;
